import { render, staticRenderFns } from "./LearningSettingsMenu.vue?vue&type=template&id=71462fc9&scoped=true&"
import script from "./LearningSettingsMenu.vue?vue&type=script&lang=js&"
export * from "./LearningSettingsMenu.vue?vue&type=script&lang=js&"
import style0 from "./LearningSettingsMenu.vue?vue&type=style&index=0&id=71462fc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71462fc9",
  null
  
)

export default component.exports